import {
  APP_CHECK_VIEW_PORT,
  APP_UPDATE_PROGRESS,
} from './types';

export const checkViewPort = desktopBreakPoint => ({
  type: APP_CHECK_VIEW_PORT,
  payload: !desktopBreakPoint.matches,
});

/**
 * Updates the mounted state for specific
 * Provider Dashboard components.
 */
export const updateProgress = progress => ({
  type: APP_UPDATE_PROGRESS,
  payload: progress,
});
